import { Theme } from '@mui/material/styles';
import { createStyles } from "@mui/styles";

export const InputAutoCompleteStyles = (theme: Theme) => createStyles({

    autocompleteInputRoot: {
        flexWrap: "wrap",
        "& input": {
            width: "1px",
            flexGrow: 1
        }
    },
    autocompleteChip: {
        margin: theme.spacing(1),
        "& img": {
            "object-fit": "scale-down"
        }
    },

    autocompleteLimitedWidth: {
        maxWidth: "200px",
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "block"
    }
});